import { render, staticRenderFns } from "./AccountTransaction.vue?vue&type=template&id=36b86ff4"
import script from "./AccountTransaction.vue?vue&type=script&lang=js"
export * from "./AccountTransaction.vue?vue&type=script&lang=js"
import style0 from "./AccountTransaction.vue?vue&type=style&index=0&id=36b86ff4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports